import { axInstBasic } from "../../components/Service/Service";

export const getArnPayload = (parArn, childArn, filterPayload = {}) => {
  const base = {
    ...(childArn ? { childArn } : { parArn }),
    ...filterPayload,
  };

  Object.keys(base).forEach((key) => {
    if (Array.isArray(base[key]) && base[key].length === 0) {
      delete base[key];
    }
  });

  return base;
};

export const getTotalVehicle = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}total-vehicles`,
      values
    );
    // console.log("API response (total-vehicles):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching total-vehicles:", error);
    throw error;
  }
};

// 1.
export const firstPurchaseDate = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}first-purchase-date`,
      values
    );
    // console.log("API response (first-purchase-date):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching first-purchase-date:", error);
    throw error;
  }
};

// 2.
export const lastPurchaseDate = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}last-purchase-date`,
      values
    );
    // console.log("API response (last-purchase-date):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching last-purchase-date:", error);
    throw error;
  }
};

// export const totalvehicle = async (arn, childArn, filterPayload) => {
//   const values = getArnPayload(arn, childArn, filterPayload);
//   try {
//     const res = await axInstBasic.post(
//       `${process.env.REACT_APP_API_URL}totalVehicles`,
//       values
//     );
//     // console.log("API response (last-purchase-date):", res.data);
//     return res.data.doc_count;
//   } catch (error) {
//     console.error("Error fetching last-purchase-date:", error);
//     throw error;
//   }
// };
// 3.
export const stateGraphData = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}state-graph-data`,
      values
    );
    // console.log("API response (state-graph-data):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching state-graph-data:", error);
    throw error;
  }
};

// 4.
export const stateVehicleCountData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}state-vehicle-count-data`,
      values
    );
    // console.log("API response (state-vehicle-count-data):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching state-vehicle-count-data:", error);
    throw error;
  }
};

// 5.
export const avgKmWiseVehicle = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avg-km-wise-vehicle`,
      values
    );
    // console.log("API response (avg-km-wise-vehicle):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching avg-km-wise-vehicle:", error);
    throw error;
  }
};

// 6.
export const avgKmTable = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avg-km-table`,
      values
    );
    // console.log("API response (avg-km-table):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching avg-km-table:", error);
    throw error;
  }
};

// 7.
export const productLineWiseBoxes = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}productLine-wise-boxes`,
      values
    );
    // console.log("API response (productLine-wise-boxes):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching productLine-wise-boxes:", error);
    throw error;
  }
};

// 8. (Missing in your provided code, assuming it's meant to be here if it exists)

// 9.
export const stateList = async (parArn, childArn, filterPayload) => {
  // Adde
  const values = getArnPayload(parArn, childArn, filterPayload); // Passe
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}state-list`,
      values
    );
    // console.log("API response (state-list):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching state-list:", error);
    throw error;
  }
};

// 10.
export const getYears = async (parArn, childArn, filterPayload) => {
  // Adde
  const values = getArnPayload(parArn, childArn, filterPayload); // Passe
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}get-years`,
      values
    );
    // console.log("API response (get-years):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching get-years:", error);
    throw error;
  }
};

// 11.
export const getDealerNames = async (parArn, childArn, filterPayload) => {
  // Adde
  const values = getArnPayload(parArn, childArn, filterPayload); // Passe
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}get-dealer-names`,
      values
    );
    // console.log("API response (get-dealer-names):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching get-dealer-names:", error);
    throw error;
  }
};

// 12.
export const getLob = async (parArn, childArn, filterPayload) => {
  // Adde
  const values = getArnPayload(parArn, childArn, filterPayload); // Passe
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}get-Lob`,
      values
    );
    // console.log("API response (get-Lob):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching get-Lob:", error);
    throw error;
  }
};

// 13.
export const getPpl = async (parArn, childArn, filterPayload) => {
  // Adde
  const values = getArnPayload(parArn, childArn, filterPayload); // Passe
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}get-ppl`,
      values
    );
    // console.log("API response (get-ppl):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching get-ppl:", error);
    throw error;
  }
};

// 14.
export const getpl = async (parArn, childArn, filterPayload) => {
  // Adde
  const values = getArnPayload(parArn, childArn, filterPayload); // Passe
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}get-pl`,
      values
    );
    // console.log("API response (pl):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching pl:", error);
    throw error;
  }
};
